import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CustomerType } from "src/app/models/customer";
import { fadeInOut } from "src/app/services/animations";
import { Sales } from "../../../../models/sales";
import { Tax } from "src/app/models/tax";
import { EntityDataSourceCustomBindReport } from "src/app/services/entity.datasource";
import { SalesLineService } from "src/app/services/salesLine.service";
import { PrintLayoutService } from "src/app/components/print-layout/print-layout.service";
import { roundTo } from "round-to";

import { User } from "src/app/core/models/user.model";
import { BusinessType } from "src/app/models/businessType";
import { AuthService } from "src/app/core/services/auth.service";
import { Location } from "src/app/models/location";

@Component({
  selector: "app-print-mvr-quotation",
  templateUrl: "./print-mvr-quotation.component.html",
  styleUrls: ["./print-mvr-quotation.component.scss"],
  animations: [fadeInOut],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrintMvrQuotationComponent implements OnInit {
  displayedColumnsSOLine: string[] = [
    "itemCode",
    "description",
    "uom",
    "rate",
    "qty",
    "discount",
    "amount",
  ];

  id: number;
  sales: Sales;
  tax: Tax;
  dataSourceSOLine: any[] = [];
  dataSource: EntityDataSourceCustomBindReport;
  readonly endpointUrl = "/api/salesLines/GetSalesLineView";
  lineCount: number = 0;

  businessTypeBE: BusinessType;
  locationBE: Location;
  applicationUser: User;

  constructor(
    private printLayoutService: PrintLayoutService,
    private salesLineService: SalesLineService,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {
    this.applicationUser = this.authService.currentUser;
    this.businessTypeBE = this.authService.currentBusiness;
    this.locationBE = this.authService.currentLocation;

    this.id = Number(this.route.snapshot.paramMap.get("id"));

    this.route.data.subscribe(({ sales }) => {
      if (sales) {
        this.sales = sales;
      }
    });

    this.route.data.subscribe(({ tax }) => {
      if (tax) {
        this.tax = tax;
      }
    });
  }

  ngOnInit() {
    this.dataSource = new EntityDataSourceCustomBindReport(
      this.salesLineService,
      this.endpointUrl
    );

    this.dataSource.loadReport(this.id, this.displayedColumnsSOLine);
    this.dataSource.entityCount$.subscribe((c) => (this.lineCount = c));
    this.dataSource.currentData$.subscribe((rows) => {
      this.dataSourceSOLine = rows;
    });
  }

  getDescription(row: any) {
    let description: string = row.productName;

    if (row.remark) {
      description += " (" + row.remark + ")";
    }
    if (row.storageRemark) {
      description += " ~ " + row.storageRemark + " ~ ";
    }
    return description;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.printLayoutService.onDataReady();
    }, 1000);
  }

  getCustomerType(value: string | number) {
    return CustomerType[value];
  }

  financialFormat(x: number) {
    return roundTo(x, 2);
  }
}
